import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'

import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import _ from 'lodash'

import { MenuItem, Box, IconButton, Tooltip, Button } from '@mui/material'

import SaveAltIcon from '@mui/icons-material/SaveAlt'

import ListOutlinedIcon from '@mui/icons-material/ListOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import DataExportDialog from '/components/data-export-dialog'
import excelExport from './active-passes-list-to-excel'
import StyledPaper from '../paper.jsx'
import { createTableStyles } from '../table-styles'


const ActivePassesTable = ({ activePasses }) => {
  const theme = useTheme()
  const tableStyles = useMemo(() => createTableStyles(theme), [theme])

  const [dataExportDialogOpen, setDataExportDialogOpen] = useState(false)

  const totalActivePasses = useMemo(() => _.sum(activePasses.map(t => t.counter)), [activePasses])

  const navigate = useNavigate()

  const viewPasses = (rowId) => {
    navigate(`/templates/${activePasses[rowId].template_id}/passes`)
  }

  const viewTemplate = (rowId) => {
    navigate(`/templates/${activePasses[rowId].template_id}`)
  }

  const columns = useMemo(() => [
    {
      accessorKey: 'name',
      header: 'Template Name',
      filterVariant: 'autocomplete',
      size: 200,
      Footer: () => "Totals"
    },
    {
      accessorKey: 'template_id',
      header: 'Template ID',
      filterVariant: 'autocomplete',
      size: 200,
      Cell: ({ cell }) => <Button onClick={() => navigate(`/templates/${cell.getValue()}/passes`)}><OpenInNewIcon className='mr-2' /> {cell.getValue()}</Button>,
    },
    {
      accessorKey: 'counter',
      header: 'Active Passes',
      filterVariant: 'range',
      filterFn: 'between',
      size: 20,
      Cell: ({ cell }) => numberFormat(cell.getValue()),
      muiTableBodyCellProps: {
        align: 'right',
      },
      muiTableHeadCellProps: {
        align: 'right',
      },
      muiTableFooterCellProps: {
        align: 'right',
      },
      Footer: () => totalActivePasses
    },
  ])

  const table = useMaterialReactTable({
    columns,
    data: activePasses,
    state: {
      isLoading: false
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.id,
    ...tableStyles,

    renderRowActionMenuItems: ({ closeMenu, row }) =>
      [
        <MenuItem key={1} onClick={() => { viewPasses(parseInt(row.id, 10)); closeMenu() }}><ListOutlinedIcon className='mr-2' /> View Issued Passes </MenuItem>,
        <MenuItem key={2} onClick={() => { viewTemplate(parseInt(row.id, 10)); closeMenu() }}><ListOutlinedIcon className='mr-2' /> View Template </MenuItem>,
      ],
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
        <Tooltip title="Export"><IconButton onClick={() => setDataExportDialogOpen(true)}><SaveAltIcon /></IconButton></Tooltip>
      </Box>
    )
  })

  return (
    <StyledPaper sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }} height="100vh">
      <MaterialReactTable table={table} />
      <DataExportDialog open={dataExportDialogOpen} setOpen={setDataExportDialogOpen} fileName="active-passes" data={activePasses} excelExport={excelExport} />
    </StyledPaper>
  )
}

export default ActivePassesTable

const numberFormat = value => <span className={value === 0 ? "grey" : ""}>{value?.toLocaleString()}</span>